import { Upload, X } from "lucide-react";
import CustomInput from "../../shared/CustomInput";
import Loading from "../../shared/Loading";
import { useRef, useState } from "react";
import { uploadImage } from "../../sdk/upload/upload";

const AddGuarantor = ({
  closeAddGuarantor,
  handleAddMyGuarantor,
  guarantor,
  setGuarantor,
  loading,
}) => {
  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);

  const [guarantorPhoto, setGuarantorPhoto] = useState(null);
  const [businessPhoto, setBusinessPhoto] = useState(null);

  const [guarantorPhotoUrl, setGuarantorPhotoUrl] = useState(null);
  const [businessPhotoUrl, setBusinessPhotoUrl] = useState(null);

  const handleChooseFileClick1 = () => fileInputRef1.current?.click();
  const handleChooseFileClick2 = () => fileInputRef2.current?.click();

  const handleFileChange1 = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setGuarantorPhoto(file);
      const response = await uploadImage(file);
      if (response?.url) {
        setGuarantorPhotoUrl(response.url);
        setGuarantor((prev) => ({
          ...prev,
          guarantorPhoto: response.url,
        }));
      }
    }
  };

  const handleFileChange2 = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const response = await uploadImage(file);
      setBusinessPhoto(file);
      if (response?.url) {
        setBusinessPhotoUrl(response.url);
        setGuarantor((prev) => ({
          ...prev,
          guarantorBusinessPhoto: response.url,
        }));
      }
    }
  };
  return (
    <div
      onClick={(e) => {
        closeAddGuarantor();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[850px] h-[600px] rounded-[10px] p-[20px] relative bg-white"
      >
        <div
          onClick={closeAddGuarantor}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div className="absolute bottom-[20px] right-[20px]">
          <button
            disabled={loading}
            onClick={handleAddMyGuarantor}
            className="h-[35px] bg-[#000000] flex items-center justify-center gap-[5px] rounded-[30px] px-[15px] text-[15px] font-bold text-white"
          >
            {loading && <Loading />}
            Add Guarantor
          </button>
        </div>
        <div>
          <p className="text-[#000000] text-[20px] font-semibold">
            Add Guarantor
          </p>
          <p className="text-[#5C5C5C] text-[14px] font-normaal">
            Add guarantor details
          </p>
          <div className="flex items-center gap-[20px] my-[10px]">
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="Guarantor Name"
              >
                Guarantor Name
              </label>
              <CustomInput
                placeholder="Enter your guarantor name"
                type="text"
                value={guarantor?.guarantorName}
                onChange={(e) =>
                  setGuarantor({
                    ...guarantor,
                    guarantorName: e.target.value,
                  })
                }
              />
            </div>
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="Guarantor Location"
              >
                Guarantor Location
              </label>
              <CustomInput
                placeholder="Enter your guarantor location"
                type="text"
                value={guarantor?.residenceLocation}
                onChange={(e) =>
                  setGuarantor({
                    ...guarantor,
                    residenceLocation: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="flex items-center gap-[20px] my-[10px]">
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="Phone Number"
              >
                Phone Number
              </label>
              <CustomInput
                placeholder="Enter your phone number"
                type="text"
                value={guarantor?.guarantorPhone}
                onChange={(e) =>
                  setGuarantor({
                    ...guarantor,
                    guarantorPhone: e.target.value,
                  })
                }
              />
            </div>
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="Email"
              >
                Email
              </label>
              <CustomInput
                placeholder="Enter your email"
                type="text"
                value={guarantor?.guarantorEmail}
                onChange={(e) =>
                  setGuarantor({
                    ...guarantor,
                    guarantorEmail: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="flex items-center gap-[20px] my-[10px]">
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="Guarantee amount"
              >
                Guarantee Amount
              </label>
              <CustomInput
                placeholder="Enter your guarantee amount"
                type="text"
                value={guarantor?.guaranteeAmount}
                onChange={(e) =>
                  setGuarantor({
                    ...guarantor,
                    guaranteeAmount: e.target.value,
                  })
                }
              />
            </div>
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="Location Link"
              >
                Location Link
              </label>
              <CustomInput
                placeholder="Enter your location link"
                type="text"
                value={guarantor?.residenceWard}
                onChange={(e) =>
                  setGuarantor({
                    ...guarantor,
                    residenceWard: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="flex items-start gap-[20px] my-[10px]">
            {/* Guarantor Photo */}
            <div className="flex w-[45%] my-[20px] flex-col">
              <p className="text-[#222222] font-medium text-[13px]">
                Guarantor Photo{" "}
                <span className="font-normal text-[#5C5C5C]">
                  .jpeg or .png file only
                </span>
              </p>
              <div
                className="min-h-[90px] px-[10px] py-[12px] flex flex-col gap-[10px] rounded-[8px] border border-[#A8A8A8] bg-white cursor-pointer"
                onClick={handleChooseFileClick1}
              >
                {guarantorPhoto ? (
                  <div className="flex flex-col items-center">
                    <p className="text-[12px] font-semibold text-black truncate">
                      {guarantorPhoto.name}
                    </p>
                    <p className="text-[11px] text-gray-500">
                      {(guarantorPhoto.size / 1024).toFixed(2)} KB
                    </p>
                    {guarantorPhotoUrl && (
                      <img
                        src={guarantorPhotoUrl}
                        alt="Guarantor"
                        className="mt-2 w-24 h-24 object-cover rounded"
                      />
                    )}
                  </div>
                ) : (
                  <div className="w-full h-full flex flex-col gap-[10px] items-center justify-center">
                    <Upload />
                    <p className="text-[#000000] text-[12px] font-normal">
                      Drag and Drop file here or{" "}
                      <span className="text-[#000000] underline">
                        Choose file
                      </span>
                    </p>
                  </div>
                )}
                <input
                  type="file"
                  ref={fileInputRef1}
                  className="hidden"
                  onChange={handleFileChange1}
                />
              </div>
            </div>

            {/* Business Photo */}
            <div className="flex w-[45%] my-[20px] flex-col">
              <p className="text-[#222222] font-medium text-[13px]">
                Guarantor Business Photo{" "}
                <span className="font-normal text-[#5C5C5C]">
                  .jpeg or .png file only
                </span>
              </p>
              <div
                className="min-h-[90px] px-[10px] py-[12px] flex flex-col gap-[10px] rounded-[8px] border border-[#A8A8A8] bg-white cursor-pointer"
                onClick={handleChooseFileClick2}
              >
                {businessPhoto ? (
                  <div className="flex flex-col items-center">
                    <p className="text-[12px] font-semibold text-black truncate">
                      {businessPhoto.name}
                    </p>
                    <p className="text-[11px] text-gray-500">
                      {(businessPhoto.size / 1024).toFixed(2)} KB
                    </p>
                    {businessPhotoUrl && (
                      <img
                        src={businessPhotoUrl}
                        alt="Business"
                        className="mt-2 w-24 h-24 object-cover rounded"
                      />
                    )}
                  </div>
                ) : (
                  <div className="w-full h-full flex flex-col gap-[10px] items-center justify-center">
                    <Upload />
                    <p className="text-[#000000] text-[12px] font-normal">
                      Drag and Drop file here or{" "}
                      <span className="text-[#000000] underline">
                        Choose file
                      </span>
                    </p>
                  </div>
                )}
                <input
                  type="file"
                  ref={fileInputRef2}
                  className="hidden"
                  onChange={handleFileChange2}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddGuarantor;
